module.exports = __webpack_public_path__ + "static/media/MentorChristinediBella.f31bdcef.jpg";